<template>
  <footer class="bg-marketing-dark text-light">
    <CContainer class="py-5">
      <!-- Footer Grid -->
      <CRow class="mb-4">
        <!-- Company Info -->
        <CCol cols="12" md="3" class="mb-4 mb-md-0">
          <div class="d-flex align-items-center mb-3">
            <CIcon name="cil-user" size="2xl" class="text-marketing-accent mr-2"/>
            <span class="h5 mb-0 font-weight-bold text-white">Niagaku</span>
          </div>
          <p class="small mb-3" style="color: rgba(255, 255, 255, 0.7);">
            Accounting & Payroll software designed for Malaysian SMEs. Automate your business operations with confidence.
          </p>
          <div class="d-flex">
            <a href="https://facebook.com" target="_blank" rel="noopener" class="text-muted mr-3" style="text-decoration: none;">
              <CIcon name="cib-facebook" size="lg"/>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener" class="text-muted mr-3" style="text-decoration: none;">
              <CIcon name="cib-twitter" size="lg"/>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener" class="text-muted" style="text-decoration: none;">
              <CIcon name="cib-linkedin" size="lg"/>
            </a>
          </div>
        </CCol>

        <!-- Product Links -->
        <CCol cols="12" sm="4" md="3" class="mb-4 mb-md-0">
          <h6 class="text-white font-weight-semibold mb-3">Product</h6>
          <ul class="list-unstyled">
            <li class="mb-2">
              <router-link to="/features" class="text-muted" style="text-decoration: none;">Features</router-link>
            </li>
            <li class="mb-2">
              <router-link to="/pricing" class="text-muted" style="text-decoration: none;">Pricing</router-link>
            </li>
            <li class="mb-2">
              <router-link to="/calculators" class="text-muted" style="text-decoration: none;">Free Calculators</router-link>
            </li>
            <li class="mb-2">
              <router-link to="/features/payroll" class="text-muted" style="text-decoration: none;">Payroll</router-link>
            </li>
            <li class="mb-2">
              <router-link to="/features/invoicing" class="text-muted" style="text-decoration: none;">Invoicing</router-link>
            </li>
            <li class="mb-2">
              <router-link to="/features/accounting" class="text-muted" style="text-decoration: none;">Accounting</router-link>
            </li>
          </ul>
        </CCol>

        <!-- Resources Links -->
        <CCol cols="12" sm="4" md="3" class="mb-4 mb-md-0">
          <h6 class="text-white font-weight-semibold mb-3">Resources</h6>
          <ul class="list-unstyled">
            <li class="mb-2">
              <router-link to="/guides" class="text-muted" style="text-decoration: none;">Guides</router-link>
            </li>
            <li class="mb-2">
              <router-link to="/blog" class="text-muted" style="text-decoration: none;">Blog</router-link>
            </li>
            <li class="mb-2">
              <router-link to="/help" class="text-muted" style="text-decoration: none;">Help Center</router-link>
            </li>
            <li class="mb-2">
              <router-link to="/api" class="text-muted" style="text-decoration: none;">API Documentation</router-link>
            </li>
            <li class="mb-2">
              <a href="https://mysst.customs.gov.my" target="_blank" rel="noopener" class="text-muted" style="text-decoration: none;">
                RMCD MySST Portal
                <CIcon name="cil-external-link" size="sm" class="ml-1"/>
              </a>
            </li>
          </ul>
        </CCol>

        <!-- Company Links -->
        <CCol cols="12" sm="4" md="3" class="mb-4 mb-md-0">
          <h6 class="text-white font-weight-semibold mb-3">Company</h6>
          <ul class="list-unstyled">
            <li class="mb-2">
              <router-link to="/about" class="text-muted" style="text-decoration: none;">About Us</router-link>
            </li>
            <li class="mb-2">
              <router-link to="/contact" class="text-muted" style="text-decoration: none;">Contact</router-link>
            </li>
            <li class="mb-2">
              <router-link to="/privacy" class="text-muted" style="text-decoration: none;">Privacy Policy</router-link>
            </li>
            <li class="mb-2">
              <router-link to="/terms" class="text-muted" style="text-decoration: none;">Terms of Service</router-link>
            </li>
            <li class="mb-2">
              <router-link to="/login" class="text-muted" style="text-decoration: none;">Login</router-link>
            </li>
            <li class="mb-2">
              <router-link to="/signup" class="text-marketing-accent font-weight-medium" style="text-decoration: none;">Sign Up</router-link>
            </li>
          </ul>
        </CCol>
      </CRow>

      <!-- Bottom Bar -->
      <div class="border-top pt-4 mt-4" style="border-color: rgba(255, 255, 255, 0.1) !important;">
        <CRow class="align-items-center">
          <CCol cols="12" md="6" class="text-center text-md-left mb-3 mb-md-0">
            <p class="small text-muted mb-0">
              &copy; {{ currentYear }} Niagaku. All rights reserved.
            </p>
          </CCol>
          <CCol cols="12" md="6" class="text-center text-md-right">
            <div class="d-inline-flex align-items-center">
              <CIcon name="cil-heart" size="sm" class="text-danger mr-2"/>
              <span class="small text-muted">Made in Malaysia</span>
            </div>
          </CCol>
        </CRow>
      </div>
    </CContainer>
  </footer>
</template>

<script>
export default {
  name: 'MarketingFooter',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
/* Footer uses CoreUI components and Bootstrap 4 classes */
</style>
